"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var Error_1 = require("../InputModules/Error");
var uuid_1 = require("uuid");
var containerStyle = function (allGroupDirection) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-flow: ", ";\n  ", "\n"])), allGroupDirection !== null && allGroupDirection !== void 0 ? allGroupDirection : 'column', allGroupDirection === 'row' && (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      align-items: center; gap: 16px;\n\n      label {\n        margin-bottom: 0;\n        padding-bottom: 0;\n      }\n    "], ["\n      align-items: center; gap: 16px;\n\n      label {\n        margin-bottom: 0;\n        padding-bottom: 0;\n      }\n    "])))); };
var baseStyle = function (allGroupDirection, radioGroupDirection) { return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 4px;\n  display: flex;\n  flex-flow: ", ";\n  /* stylelint-disable-next-line */\n  gap: ", ";\n"], ["\n  border-radius: 4px;\n  display: flex;\n  flex-flow: ", ";\n  /* stylelint-disable-next-line */\n  gap: ", ";\n"])), allGroupDirection !== null && allGroupDirection !== void 0 ? allGroupDirection : radioGroupDirection, allGroupDirection === 'row' || (allGroupDirection !== 'column' && radioGroupDirection === 'row') ? '16px' : '8px'); };
var labelColor = function (isDisabled, selectedTheme) {
    if (selectedTheme === 'dark') {
        return isDisabled ? design_system_foundations_1.theme.color.neutral40 : design_system_foundations_1.theme.color.neutral10;
    }
    return isDisabled ? design_system_foundations_1.theme.color.neutral60 : design_system_foundations_1.theme.color.neutral100;
};
var labelStyle = function (isDisabled, selectedTheme) { return (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  padding-bottom: 16px;\n  color: ", ";\n"], ["\n  ", ";\n  padding-bottom: 16px;\n  color: ", ";\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'titleH5')), labelColor(isDisabled, selectedTheme)); };
exports.RadioGroup = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, error = _a.error, groupRef = _a.groupRef, isDisabled = _a.isDisabled, label = _a.label, name = _a.name, style = _a.style, testId = _a.testId, allGroupDirection = _a.allGroupDirection, // don't default for style check above
    _b = _a.radioGroupDirection, // don't default for style check above
    radioGroupDirection = _b === void 0 ? 'column' : _b, rest = __rest(_a, ["children", "className", "error", "groupRef", "isDisabled", "label", "name", "style", "testId", "allGroupDirection", "radioGroupDirection"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var uniqueId = (0, react_1.useMemo)(function () { return name || (0, uuid_1.v4)(); }, [name]);
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)(containerStyle(allGroupDirection), className, 'ds-radio-group'), style: style, "data-testid": testId }, rest, { ref: groupRef !== null && groupRef !== void 0 ? groupRef : ref }),
        label && (react_1.default.createElement("label", { id: name, className: labelStyle(isDisabled, selectedTheme), "data-testid": testId && "".concat(testId, "-label") }, label)),
        react_1.default.createElement("div", { className: baseStyle(allGroupDirection, radioGroupDirection), role: "radiogroup", "aria-labelledby": name, "data-testid": testId && "".concat(testId, "-group") },
            react_1.default.Children.map(children, function (child) {
                return react_1.default.isValidElement(child) &&
                    react_1.default.cloneElement(child, {
                        name: name,
                        isDisabled: isDisabled,
                        useInlineError: false,
                    });
            }),
            error && react_1.default.createElement(Error_1.ErrorInput, { id: uniqueId, error: error, testId: testId }))));
});
exports.RadioGroup.displayName = 'RadioGroup';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
